import { BaseModel } from '@/api/base-model'
import { TypeformFormAPI } from '@/api/backend-client'

export class TypeformResponseAnswerChoice extends BaseModel<TypeformResponseAnswerChoice> {
    protected collectionName = TypeformFormAPI.collectionName

    constructor(
        public label: string,
    ) { super(null) }

    toRequestData(): any {
        return {
            label: this.label,
        }
    }

    static fromData(data: any): TypeformResponseAnswerChoice {
        if (data === null || typeof data === 'string' || data instanceof TypeformResponseAnswerChoice) {
            return data
        }

        return new TypeformResponseAnswerChoice(
            data.label,
        )
    }
}
